var _defs, _use, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChargingActiveAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / charging_active_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.6750372%",
    y1: "0%",
    x2: "59.2912946%",
    y2: "85.4724702%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E563",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198232",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27,0 C29.209139,-4.05812251e-16 31,1.790861 31,4 L31,10 L38,10 C40.209139,10 42,11.790861 42,14 L42,80 C42,82.209139 40.209139,84 38,84 L4,84 C1.790861,84 2.705415e-16,82.209139 0,80 L0,14 C-2.705415e-16,11.790861 1.790861,10 4,10 L11,10 L11,4 C11,1.790861 12.790861,4.05812251e-16 15,0 L27,0 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.7850901%",
    y1: "-62.7377565%",
    x2: "66.0933613%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AFF4B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25D24A",
    stopOpacity: 0.670017483,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#095C05",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87BD84",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-charging_active_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Battery",
    transform: "translate(24.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Battery---Fill"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.401633523,
    fill: "#13D246",
    style: {
      mixBlendMode: "soft-light"
    },
    xlinkHref: "#path-2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,1 C27.8284271,1 28.5784271,1.33578644 29.1213203,1.87867966 C29.6642136,2.42157288 30,3.17157288 30,4 L30,4 L30,11 L38,11 C38.8284271,11 39.5784271,11.3357864 40.1213203,11.8786797 C40.6642136,12.4215729 41,13.1715729 41,14 L41,14 L41,80 C41,80.8284271 40.6642136,81.5784271 40.1213203,82.1213203 C39.5784271,82.6642136 38.8284271,83 38,83 L38,83 L4,83 C3.17157288,83 2.42157288,82.6642136 1.87867966,82.1213203 C1.33578644,81.5784271 1,80.8284271 1,80 L1,80 L1,14 C1,13.1715729 1.33578644,12.4215729 1.87867966,11.8786797 C2.42157288,11.3357864 3.17157288,11 4,11 L4,11 L12,11 L12,4 C12,3.17157288 12.3357864,2.42157288 12.8786797,1.87867966 C13.4215729,1.33578644 14.1715729,1 15,1 L15,1 Z",
    id: "Battery---Border",
    stroke: "url(#linearGradient-3)",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Level_6---Fill",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.348028274,
    points: "37.5 24.25 4.5 24.25 4.5 14.25 37.5 14.25"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Level_6---Fill",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.348028274,
    points: "37.5 35.75 4.5 35.75 4.5 25.75 37.5 25.75"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Level_6---Fill",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.348028274,
    points: "37.5 47.25 4.5 47.25 4.5 37.25 37.5 37.25"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Level_6---Fill",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.348028274,
    points: "37.5 58.75 4.5 58.75 4.5 48.75 37.5 48.75"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Level_6---Fill",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.348028274,
    points: "37.5 70.25 4.5 70.25 4.5 60.25 37.5 60.25"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Level_6---Fill",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.348028274,
    points: "37.5 81.75 4.5 81.75 4.5 71.75 37.5 71.75"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingActiveAppTile);
export default __webpack_public_path__ + "static/media/charging_active_app_tile.4d2cd19ade03b2e8a175439134fa0338.svg";
export { ForwardRef as ReactComponent };